import { useTranslation } from "react-i18next";

import HomeBanner from "src/core/assets/images/homeBanner.jpg";
import PlusButton from "src/core/assets/images/icons/plus.svg?react";
import { Spinner } from "src/core/components/custom-ui/spinner";
import { Button } from "src/core/components/ui/button";
import { Roles } from "src/core/constants/roles";
import { useUser } from "src/core/contexts/UserContext";
import { usePermissions } from "src/core/hooks/usePermissions";

type SubHeaderProps = {
  onAddClick?: () => void;
};

export const SubHeader: React.FC<SubHeaderProps> = ({ onAddClick }) => {
  const { t } = useTranslation();
  const { userName, userRole, loading } = useUser();
  const { hasRole } = usePermissions();

  return (
    <div className="home-subheader-container group">
      <div className="flex flex-col items-start h-subheader">
        <img src={HomeBanner} alt="Home Banner" className="h-[50px] object-contain" />
        <div className="home-subheader-user">
          {loading ? (
            <Spinner size="lg" data-testid="home-subheader-spinner" />
          ) : (
            <>
              <div className="text-lg font-semibold" data-testid="home-subheader-name">
                {userName}
              </div>
              <div className="text-base font-light" data-testid="home-subheader-description">
                {userRole}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="flex items-center gap-10">
        {!hasRole(Roles.AUDITEUR) && (
          <Button variant="default" onClick={onAddClick} data-testid="home-subheader-plus-button">
            <PlusButton />
            {t("home.addClient")}
          </Button>
        )}
      </div>
    </div>
  );
};
